<template>
  <div>
    <h4 class="text-bold">{{ title }}</h4>
    <div class="grid" v-for="(roll, index) in orderedRolls" :key="index">
      <div
        :class="'grid-body roll pointer bg-' + color"
        @click="getLogs(index)"
        v-if="!filterIsActive || (filterIsActive && roll.logs.length > 0)"
      >
        <div class="row">
          <div class="col-md-8 roll-title">
            <h4 class="text-bold text-white">
              <i
                class="fa fa-minus-circle"
                aria-hidden="true"
                v-if="roll.show"
              ></i>
              <i class="fa fa-plus-circle" aria-hidden="true" v-else></i>
              &nbsp; &nbsp;{{ roll.roll_code }}
              <span
                class="badge badge-white edit-length"
                @click.stop="editLength(index)"
                v-if="!isReadOnlyUser"
              >
                <i class="fa fa-edit" aria-hidden="true"></i>
                Edit Length
              </span>
            </h4>
          </div>
          <div class="col-md-4 text-right" v-if="deleteBtn">
            <button
              class="btn btn-danger"
              @click.stop="deleteRoll(index)"
              v-if="!isReadOnlyUser"
            >
              <i class="fa fa-trash-o" aria-hidden="true"></i>
              DELETE ROLL
            </button>
          </div>
          <div class="col-md-4 text-right" v-if="roll.deleted">
            <button
              class="btn btn-white"
              @click.stop="viewNote(roll.delete_note)"
            >
              <i class="fa fa-eye" aria-hidden="true"></i>
              View Note
            </button>
          </div>
        </div>
      </div>
      <table
        class="table table-bordered"
        v-if="
          (!filterIsActive && roll.show) ||
          (filterIsActive && roll.logs.length > 0)
        "
      >
        <thead>
          <tr>
            <th @click="sort('cut_reason', index)">
              Cut Reason
              <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
            <th>Shirt Order ID</th>
            <th @click="sort('length_cut', index)">
              Length Cut
              <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
            <th>Unit</th>
            <th @click="sort('created_at', index)">
              Time
              <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="log in roll.logs" :key="log.id">
            <td class="text-capitalize">
              {{ reasonFormat(log.cut_reason) }}
            </td>
            <td>
              {{ log.shirt_order_id }}
            </td>
            <td>
              {{ log.length_cut }}
            </td>
            <td>
              {{ log.unit }}
            </td>
            <td>
              {{ moment(log.created_at).format("DD MMM, YYYY h:mm a") }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <hr />
  </div>
</template>

<script>
export default {
  props: ["title", "rolls", "color", "deleteBtn", "filter", "isReadOnlyUser"],
  data() {
    return {
      orderedRolls: [],
      sortType: "asc",
    };
  },
  computed: {
    filterIsActive() {
      return this.filter.length >= 0 && this.filter !== "";
    },
  },
  methods: {
    sort(column, index) {
      this.sortType = this.sortType === "asc" ? "desc" : "asc";

      // Have to clone the entire array and mutate the original orderedRolls to trigger re-render by vue
      const newOrderedRolls = [...this.orderedRolls];

      if (newOrderedRolls[index] && newOrderedRolls[index].logs) {
        const sortedLogs = _.orderBy(
          [...newOrderedRolls[index].logs],
          [column],
          [this.sortType]
        );
        
        newOrderedRolls[index] = {
          ...newOrderedRolls[index],
          logs: sortedLogs
        };

        this.orderedRolls = newOrderedRolls;
      }
    },

    reasonFormat(str) {
      return str.replace("_", " ");
    },

    async getLogs(index) {
      if (!this.orderedRolls[index].show) {
        let id = this.orderedRolls[index].id;
        let res = await axios.get(`v2/fabrics/rolls/${id}/logs`);
        if (this.filterIsActive) {
          // Filter the logs by the shirt order number
          this.orderedRolls[index]["logs"] = res.data.data.filter((log) => {
            return parseInt(log.shirt_order_id) === parseInt(this.filter);
          });
        } else {
          this.orderedRolls[index]["logs"] = res.data.data;
        }
      }
      this.orderedRolls[index].show = !this.orderedRolls[index].show;
    },

    async editLength(index) {
      let originalLength = this.orderedRolls[index].length;
      const { value: length } = await Swal.fire({
        title: "Enter New Length",
        input: "text",
        inputValue: originalLength,
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return "Required Length!";
          } else if (!Number.isInteger(value * 1)) {
            return "Please Enter Only Number!";
          }
        },
      });
      if (length) {
        try {
          let res = await axios.put(
            "v2/fabrics/0/rolls/" + this.orderedRolls[index].id,
            {
              id: this.orderedRolls[index].id,
              length: length,
            }
          );
          if (res) {
            this.orderedRolls[index].roll_code = res.data.data.roll_code;
            toastr.success("Successfully Changed!");
          }
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
        }
      }
    },

    async deleteRoll(index) {
      const { value: text } = await Swal.fire({
        title: "Are You Sure To Delete?",
        text: "Please Write Note!",
        input: "textarea",
        inputPlaceholder: "Write your Note here...",
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return "You need to write something!";
          }
        },
      });

      if (text) {
        let { id } = this.orderedRolls[index];
        try {
          let res = await axios.delete("v2/fabrics/0/rolls/" + id, {
            params: { delete_note: text },
          });
          if (res) {
            this.orderedRolls.splice(index, 1);
            toastr.success("Successfully Deleted!");
          }
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
        }
      }
    },

    viewNote(note) {
      Swal.fire(note);
    },
  },
  watch: {
    rolls() {
      this.orderedRolls = this.rolls;
    },
  },
};
</script>

<style lang="scss" scoped>
.roll {
  padding: 5px 20px;
}
.grid {
  margin-bottom: 3px !important;
}
.edit-length {
  display: none;
}
.roll-title:hover {
  .edit-length {
    display: inline-block;
  }
}
</style>
